import { render } from "./PartnershipDetailInfo.vue?vue&type=template&id=86bab318&scoped=true&ts=true"
import script from "./PartnershipDetailInfo.vue?vue&type=script&lang=ts"
export * from "./PartnershipDetailInfo.vue?vue&type=script&lang=ts"

import "./PartnershipDetailInfo.vue?vue&type=style&index=0&id=86bab318&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86bab318"]])

export default __exports__